export enum CivilityEnum {
  Mr = 'Mr',
  Mrs = 'Mrs',
  Ms = 'Ms',
}
